/* eslint-disable react/sort-comp */
import { Component, JSX, PropsWithChildren } from 'react';
import { createPortal } from 'react-dom';

export default class BodyEnd extends Component<PropsWithChildren<Record<string, unknown>>> {
  el: HTMLElement;

  constructor(props: PropsWithChildren<Record<string, unknown>>) {
    super(props);
    this.el = document.createElement('div');
    // eslint-disable-next-line @stylistic/max-len
    this.el.style.display = 'contents'; // The <div> is a necessary container for our content, but it should not affect our layout. Only works in some browsers, but generally doesn't matter since this is at the end anyway. Feel free to delete this line.
  }

  componentDidMount() {
    document.body.appendChild(this.el);
  }

  componentWillUnmount() {
    document.body.removeChild(this.el);
  }

  render() {
    return createPortal(this.props.children,
      this.el) as unknown as JSX.Element;
  }
}
